import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";
import Sports from "../Sports";
import OfficeList from "../../offices/officeComponents/OfficeList";

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function FreePlayOfficeOptions() {
  return (
    <div className="flex flex-col gap-4 h-max">
      <div className="!gap-4 horizontal-options">
        <OfficeList isInput={true} />
        <Sports />
      </div>
      <Crud title="Free Play Office Options">
        <TableHeaderColumn
          dataAlign="center"
          dataField="wagerType"
          isKey
          row="0"
          rowSpan="2"
        >
          Wager Type
        </TableHeaderColumn>

        <TableHeaderColumn
          dataAlign="center"
          dataField="line"
          row="0"
          rowSpan="2"
        >
          Line
        </TableHeaderColumn>

        {/* Spread */}
        <TableHeaderColumn
          row="0"
          colSpan="2"
          dataAlign="center"
          headerAlign="center"
        >
          Spread
        </TableHeaderColumn>
        <TableHeaderColumn
          dataAlign="center"
          dataField={`online`}
          row="1"
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataAlign="center"
          dataField={`onLocal`}
          row="1"
        >
          Online
        </TableHeaderColumn>
        {/* Total */}
        <TableHeaderColumn
          row="0"
          colSpan="2"
          dataAlign="center"
          headerAlign="center"
        >
          Total
        </TableHeaderColumn>
        <TableHeaderColumn
          dataAlign="center"
          dataField={`online`}
          row="1"
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataAlign="center"
          dataField={`onLocal`}
          row="1"
        >
          Online
        </TableHeaderColumn>
        {/* $-Line */}
        <TableHeaderColumn
          row="0"
          colSpan="2"
          dataAlign="center"
          headerAlign="center"
        >
          $-Line
        </TableHeaderColumn>
        <TableHeaderColumn
          dataAlign="center"
          dataField={`online`}
          row="1"
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataAlign="center"
          dataField={`onLocal`}
          row="1"
        >
          Online
        </TableHeaderColumn>
      </Crud>
    </div>
  );
}

export default FreePlayOfficeOptions;
